import {Text as RichText, TopLevelBlock} from '@contentful/rich-text-types'
import {FC} from 'react'

import {Text, TextVariant} from '@/components/common/content/Text'
import {useCommonContent} from '@/content/common'
import {useTranslation} from '@/i18n'
import {HEADER_HEIGHT_DESKTOP} from '@/theme/sizing'
import {theme} from '@/theme/theme'
import {getScrollBehavior} from '@/utils/ui/scrollBehavior'

import {useMobile} from '../context/MobileProvider'

type ContentsListProps = {
  content: TopLevelBlock[]
}

export const ContentsList: FC<ContentsListProps> = ({content}) => {
  const {t} = useTranslation()
  const {contentsTitle} = useCommonContent()
  const isMobile = useMobile()
  const allHeadings = content.filter((item) => item.nodeType === 'heading-2')

  const handleClick = (id: string) => {
    const heading = document.getElementById(id)
    const headerHeight = isMobile ? '0px' : HEADER_HEIGHT_DESKTOP
    const offset = parseInt(headerHeight, 10) + 32
    const bodyRect = document.body.getBoundingClientRect().top
    const headingRect = heading?.getBoundingClientRect().top ?? 0
    const topPosition = headingRect - bodyRect - offset

    window.scrollTo({top: topPosition, behavior: getScrollBehavior()})
  }

  return (
    <>
      <Text variant={TextVariant.h5} element="p">
        {t(contentsTitle)}
      </Text>
      <ul className="list">
        {allHeadings.map(({content}) => {
          const value = (content[0] as RichText).value

          return (
            <li key={value} role="presentation" onClick={() => handleClick(value)}>
              <Text className="text-inline underline">{value}</Text>
            </li>
          )
        })}
      </ul>

      <style jsx>{`
        .list {
          display: flex;
          flex-direction: column;
          gap: ${theme.spacing[2]};
          margin: ${theme.spacing[3]} 0 ${theme.spacing[7]} ${theme.spacing[4]};
          list-style-type: disc;
        }
      `}</style>
    </>
  )
}
